import { API } from 'api'
import { DeleteTagsRequest, MessageResponse } from 'interfaces'
import { captureErrorSentry } from 'utils/sentry/sentryHandler'
import { SentryEvents, SentrySections } from 'utils/sentry/sentryHandler.types'

export const deleteStaticList = async (
	id: number
): Promise<MessageResponse | null> => {
	let res = null
	await API()
		.delete(`/people/static_list/${id.toString()}`)
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.PEOPLE,
					event: SentryEvents.DELETE_STATIC_LIST_ERROR,
					error,
					extra: {
						params: { id }
					}
				})
				console.warn('Error:', error.message)
			}
		)
	return res
}

export const deleteDinamicList = async (
	id: number
): Promise<MessageResponse | null> => {
	let res = null
	await API()
		.delete(`/people/dynamic_list/${id}`)
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.PEOPLE,
					event: SentryEvents.DELETE_DYNAMIC_LIST_ERROR,
					error,
					extra: {
						params: { id }
					}
				})
				console.warn('Error:', error.message)
			}
		)
	return res
}

export const deleteTags = async (
	id: number,
	body: DeleteTagsRequest
): Promise<MessageResponse | null> => {
	let res = null
	await API()
		.delete(`/people/tags/organization/${id.toString()}`, { data: body })
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.PEOPLE,
					event: SentryEvents.DELETE_TAGS_ERROR,
					error,
					extra: {
						params: { id },
						payload: body
					}
				})
				console.warn('Error:', error.message)
			}
		)
	return res
}
